import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { EnvironmentService } from '@services/environment.service';
import { MapService } from '@services/map.service';

@Component({
  selector: 'app-source-map',
  templateUrl: './source-map.component.html',
  styleUrl: './source-map.component.scss'
})
export class SourceMapComponent implements AfterViewInit, OnDestroy {
  @ViewChild("mapView", { static: false })
  mapElementRef?: ElementRef;

  constructor(
    readonly environment: EnvironmentService,
    readonly mapService: MapService,
  ) {}
 
 
 
 
  ngAfterViewInit(): void {
    this.mapService.initDefaultMap(this.mapElementRef);


    this.mapService.configureMapLayer();
  }
  ngOnDestroy(): void {
   
  }
  





}
